import BankAccountConnection from "../../../template/SDK/BankAccountConnection";
import styled from "styled-components";
import BankSelection from "../../../template/SDK/BankSelection";
import Login from "../../../template/SDK/Login";
import SuccessPage from "../../../template/SDK/Success";
import { useState } from "react";

type Page =
  | "bankAccountConnection"
  | "bankSelection"
  | "login"
  | "success"
  | "empty";

const BankAccountConnectionPage = () => {
  const [currentPage, setCurrentPage] = useState<Page>("bankAccountConnection");

  const handleNext = (nextPage: Page) => {
    setCurrentPage(nextPage);
  };
  const handleCloseIcon = () => {
    setCurrentPage("empty");
  };
  const handleBackButtonClick = (nextPage: Page) => {
    setCurrentPage(nextPage);
  };
  const renderPage = () => {
    switch (currentPage) {
      case "bankAccountConnection":
        return (
          <BankAccountConnection
            fipayLogo={"/assets/icons/fipay.svg"}
            stripeLogo={"/assets/icons/fipay.svg"}
            handleNext={() => handleNext("bankSelection")}
            onClickCloseIcon={handleCloseIcon}
          />
        );
      case "bankSelection":
        return (
          <BankSelection
            fipayLogo={"/assets/icons/fipay.svg"}
            handleNext={() => handleNext("login")}
            onClickCloseIcon={handleCloseIcon}
            handleBackButtonClick={() =>
              handleBackButtonClick("bankAccountConnection")
            }
          />
        );
      case "login":
        return (
          <Login
            handleNext={() => handleNext("success")}
            fipayLogo={"/assets/icons/fipay.svg"}
            onClickCloseIcon={handleCloseIcon}
            handleBackButtonClick={() => handleBackButtonClick("bankSelection")}
          />
        );
      case "success":
        return (
          <SuccessPage
            fipayLogo={"/assets/icons/fipay.svg"}
            onClickCloseIcon={handleCloseIcon}
          />
        );
      case "empty":
        return <PaymentWrapper />;
      default:
        return null;
    }
  };

  return (
    <PaymentWrapper>
      <IframeContainer>{renderPage()}</IframeContainer>
    </PaymentWrapper>
  );
};

export default BankAccountConnectionPage;
const PaymentWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  height: 100vh;
  background-color: #f9f9f9;
`;

const IframeContainer = styled.div`
  width: 28%;
  height: 80%;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #e6e6e6;
  background-color: white;
  padding: 1.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  justify-items: center;
  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
  }
`;
